import React from 'react';
import Header from '../components/common/header';
import MainComponent from '../components/landingPage/intro';


function Home() {
  return (
    <div>
      <Header />
      <MainComponent />
    </div>
  )
}

export default Home
